<template>
  <label class="facet-item-color cursor-pointer flex flex-grow items-center" :for="itemId || item.id" :qaid="qaid">
    <swatch :color="decodedSwatchColorName" class="mr-2" />
    <em>{{ item.displayText }}</em>
  </label>
</template>
<script>
import FacetItemText from './FacetItemText';
import Swatch from '@/components/Swatch';

export default {
  name: 'FacetItemColor',
  components: {Swatch},
  extends: FacetItemText,
  computed: {
    decodedSwatchColorName() {
      return decodeURIComponent(this.item.value).split('|')[0];
    },
  },
};
</script>
